export default {
  API_URL: '/gateway',
  COS: {
    bucket: 'ai-coach-uat-1256119856',
    region: 'ap-shanghai',
    publicCOSBaseUrl: 'ai-coach-uat-1256119856.cos.ap-shanghai.myqcloud.com/public/'
  },
  PRODUCT_CODE: 'AI_COACH',
  H5PreviewHost: 'https://uat.project.hrtps.com/ai-coach-webview/operate/',
  H5: 'https://coach-h5-uat.hrtps.com/', //  小程序 h5 版
  Matrix_Admin: 'https://matrix-admin-uat.hrtps.com'
};
